<script setup lang="ts">

import {ProjectNavigationItem} from "@/types";
import {router} from "@inertiajs/vue3";

interface Props {
    items: Array<ProjectNavigationItem>,
}

const props = defineProps<Props>()

const isRouteActive = (name: string) => {
    return route().current(name)
}

const goToRoute = (url: string) => {
    router.visit(route(url))
}
</script>

<template>
    <v-list>
        <div
            v-for="(item, key) in items"
            :key="key"
        >
            <v-divider
                v-if="item.route === undefined"
                class="my-1"
            />
            <v-list-subheader
                v-if="item.route === undefined"
                class="font-weight-bold text-caption"
                :title="item.label"
            />
            <v-list-item
                v-else
                density="compact"
                rounded="lg"
                :link="true"
                :active="isRouteActive(item.route)"
                :prepend-icon="item.icon"
                active-class="is-active"
                @click="goToRoute(item.route)"
            >
                <template #prepend>
                    <v-icon size="20">
                        {{ item.icon }}
                    </v-icon>
                </template>
                <v-list-item-title
                    class="text-body-2"
                    :class="isRouteActive(item.route) ? 'font-weight-bold' : null"
                >
                    {{ item.label }}
                </v-list-item-title>
            </v-list-item>
        </div>
    </v-list>
</template>

<style scoped>
:deep(.v-list-subheader) {
    max-height: 20px !important;
}

:deep(.v-list-item__prepend) {
    width: 30px;
}
</style>
